import { DESIGN_TOKENS } from '@disqotech/vinyl-design-system/design-tokens';
import { DEVICE_BREAKPOINT, LABEL_SMALL, MOBILE_HEADER_HEIGHT, TITLES_NORMAL } from 'Shared/styles/designConstants';
import styled from 'styled-components';

export const ContentContainer = styled.div`
  max-width: 414px;
  padding  : 40px 16px;
  margin   : 0 auto;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    margin-top: ${MOBILE_HEADER_HEIGHT};
  }
`;

export const MessageContainer = styled.p`
  ${LABEL_SMALL.DEFAULT}
  display    : flex;
  align-items: center;
  color      : ${DESIGN_TOKENS.color.text.normal.value};
  background : ${DESIGN_TOKENS.color.background.info.light.value};
  padding    : 16px 20px 16px 0;

  svg {
    height     : 44px;
    width      : 44px;
    margin-left: 16px;
  }

  span {
    margin-left: 16px;
  }
`;

export const ButtonContainer = styled.div`
  ${TITLES_NORMAL.FT_01}
  margin-top: 60px;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    margin-top: 40px;
  }
`;

